@if (categories && categories.length) {
  <span class="search-title">{{ 'Search by category' | translate }}</span>
  <div class="category-list">
    @for (category of categories; track category) {
      <div class="category-list__item">
        <img
          loading="lazy"
          width="16"
          src="../../../../../assets/images/header-icons/search-icon.svg"
          alt=""
        />
        <div class="category-right">
          <a
            (click)="toggleAutocomplete.emit()"
            sRouterLink="category/{{ category.url_path }}"
          >
            {{ category.name }}</a
          >
          <span class="sub-info">{{ 'in' | translate | async }} {{ category.name }}</span>
        </div>
      </div>
    }
  </div>
}
